import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../../state/state.types';

const mapState = ({ queryParams, search }: StateType) => ({
  originalQueryKey: queryParams.originalQueryKey,
  enableSnippets: search.enableSnippets,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
